<style lang="scss" scoped>
.activities-row {
    display: flex;
    flex-flow: wrap;
    margin: 0 -12px;

    .activity-card {
        padding: 0 12px;
        flex-grow: 1;
        flex: none;
        margin-bottom: 32px;

        @media screen and (max-width: 1279.98px) {
            width: 25% !important;
        }

        @media screen and (max-width: 1023.98px) {
            width: 33.33% !important;
            width: calc(100% / 3) !important;
        }

        @media screen and (max-width: 575.98px) {
            width: 50% !important;
        }
    }
}
::v-deep .tns-ovh {
    overflow: visible;

    .tns-inner {
        @media screen and (max-width: 1279.98px) {
            overflow: scroll !important;
            margin-right: -160px !important;
            margin-left: -160px !important;
            padding-left: 160px !important;

            .tns-slider {
                > div:last-child {
                    margin-right: 144px !important;
                }
            }

            ::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE 10+ */
        }

        @media screen and (max-width: 575.98px) {
            margin-right: -24px !important;
            margin-left: -24px !important;
            padding-left: 24px !important;


            .tns-slider {
                > div:last-child {
                    margin-right: 8px !important;
                }
            }
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="row" v-if="!$root.isMobile || forceGrid">
            <div :class="col">
                <div v-if="title || cta" class="mb-40 d-flex flex-wrap w-100">
                    <h3 v-if="title" v-html="title" class="title"></h3>
                    <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
                </div>
                <slide-y-down-transition group class="activities-row" tag="div">
                    <activity-card v-show="show" class="activity-card" :class="{ 'mb-40' : activities.length > itemsPerRow }" v-for="activity in activities" :key="activity.id" :activity="activity" :style="{ width: `calc(100% / ${item_count})`}" :ratio="ratio" @updated="$emit('updated')" />
                </slide-y-down-transition>
            </div>
        </div>
        <div v-show="$root.isMobile && !forceGrid" class="row">
            <div :class="col">
                <h3 v-html="title" class="title mb-32"></h3>
                <div class="w-100" ref="sliderParent">
                    <div class="activities-slider" ref="slider">
                        <activity-card v-for="activity in activities" :key="activity.id" class="activity-card mb-40" :activity="activity" :ratio="mobileRatio" @updated="$emit('updated')" />
                    </div>
                </div>
                <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
            </div>
        </div>
    </div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider.module"
import activitesRow from "../mixins/activities-row";
import mobileSlider from "../mixins/mobile-slider";
import hasCta from "../mixins/has-cta";
import { SlideYDownTransition } from 'vue2-transitions'

export default {
    name: "pagePart.activities-row",

    mixins: [activitesRow, mobileSlider, hasCta],

    components: { SlideYDownTransition },

    props: {
        itemsPerRow: {
            type: Number,
            default: null,
        },
        ratio: {
            type: String,
            required: true,
        },
        col: {
            type: String,
            default: 'col-12'
        },
        forceGrid: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: (vm) => ({
        show: false
    }),

    mounted() {
        this.show = true;
    },

    computed: {
        item_count() {
            if (this.itemsPerRow) return this.itemsPerRow
            if (this.activities.length > 5) return 6;
            return this.activities.length
        },
    }
}
</script>